import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const CONTENT = {
  fr: {
    title: "Politique de confidentialité",
    intro: "BentSkin Go respecte votre vie privée conformément au RGPD (UE 2016/679). Cette page explique quelles données nous collectons et pourquoi.",
    sections: [
      ["Données collectées", "Nom, prénom, téléphone, e-mail, adresse, IBAN, numéro de TVA, pièces justificatives (carte d'identité, permis, carte grise) et données de géolocalisation pendant les courses."],
      ["Finalités", "Inscription des chauffeurs, mise en relation avec les passagers, paiements sécurisés (Stripe), sécurité des courses et obligations légales/comptables."],
      ["Base légale", "Exécution du contrat, obligations légales, et votre consentement (case à cocher lors de l'inscription)."],
      ["Conservation", "Vos données sont conservées le temps de la relation contractuelle puis archivées selon les délais légaux."],
      ["Vos droits", "Accès, rectification, effacement, portabilité et opposition. Contact : privacy@bentskingo.com."],
      ["Paiements", "Les paiements par carte sont traités par Stripe ; nous ne stockons pas vos numéros de carte."],
    ],
  },
  nl: {
    title: "Privacybeleid",
    intro: "BentSkin Go respecteert uw privacy conform de GDPR (EU 2016/679). Deze pagina legt uit welke gegevens we verzamelen en waarom.",
    sections: [
      ["Verzamelde gegevens", "Naam, voornaam, telefoon, e-mail, adres, IBAN, btw-nummer, bewijsstukken (identiteitskaart, rijbewijs, kentekenbewijs) en locatiegegevens tijdens ritten."],
      ["Doeleinden", "Registratie van chauffeurs, koppeling met passagiers, beveiligde betalingen (Stripe), veiligheid van ritten en wettelijke/boekhoudkundige verplichtingen."],
      ["Rechtsgrond", "Uitvoering van het contract, wettelijke verplichtingen en uw toestemming (vinkje bij registratie)."],
      ["Bewaring", "Uw gegevens worden bewaard tijdens de contractuele relatie en daarna gearchiveerd volgens de wettelijke termijnen."],
      ["Uw rechten", "Inzage, correctie, verwijdering, overdraagbaarheid en bezwaar. Contact: privacy@bentskingo.com."],
      ["Betalingen", "Kaartbetalingen worden verwerkt door Stripe; wij bewaren geen kaartnummers."],
    ],
  },
  en: {
    title: "Privacy Policy",
    intro: "BentSkin Go respects your privacy in accordance with the GDPR (EU 2016/679). This page explains what data we collect and why.",
    sections: [
      ["Data collected", "First name, last name, phone, email, address, IBAN, VAT number, supporting documents (ID card, licence, vehicle registration) and location data during rides."],
      ["Purposes", "Driver registration, matching with passengers, secure payments (Stripe), ride safety and legal/accounting obligations."],
      ["Legal basis", "Performance of the contract, legal obligations, and your consent (checkbox at registration)."],
      ["Retention", "Your data is kept for the duration of the contractual relationship, then archived per legal periods."],
      ["Your rights", "Access, rectification, erasure, portability and objection. Contact: privacy@bentskingo.com."],
      ["Payments", "Card payments are processed by Stripe; we do not store your card numbers."],
    ],
  },
};

export default function Privacy() {
  const navigate = useNavigate();
  const [lang, setLang] = useState("fr");
  const c = CONTENT[lang];
  return (
    <div className="min-h-screen bg-[#FDF8F0]">
      <div className="max-w-2xl mx-auto px-5 py-8">
        <button data-testid="privacy-back" onClick={() => navigate(-1)} className="flex items-center gap-2 text-[#75807A] hover:text-[#1A1A1A] text-sm font-medium">
          <ArrowLeft className="w-4 h-4" /> Retour
        </button>
        <div className="mt-6 flex gap-2" data-testid="privacy-lang">
          {["fr", "nl", "en"].map((l) => (
            <button key={l} data-testid={`privacy-lang-${l}`} onClick={() => setLang(l)}
              className={`px-4 h-10 rounded-full text-sm font-bold uppercase transition-colors ${lang === l ? "bg-[#2563EB] text-white" : "bg-white border border-[#E2DFD8] text-[#75807A]"}`}>
              {l}
            </button>
          ))}
        </div>
        <div className="mt-6 bg-white rounded-3xl border border-[#E2DFD8] p-7">
          <div className="w-12 h-12 rounded-2xl bg-[#2563EB] flex items-center justify-center"><ShieldCheck className="w-6 h-6 text-white" /></div>
          <h1 data-testid="privacy-title" className="mt-4 font-head font-black text-2xl text-[#1A1A1A]">{c.title}</h1>
          <p className="mt-2 text-sm text-[#75807A]">{c.intro}</p>
          <div className="mt-6 space-y-5">
            {c.sections.map(([h, body], i) => (
              <div key={i}>
                <h2 className="font-head font-bold text-[#1A1A1A]">{h}</h2>
                <p className="mt-1 text-sm text-[#3B423E] leading-relaxed">{body}</p>
              </div>
            ))}
          </div>
          <p className="mt-8 text-xs text-[#75807A]">BentSkin Go · privacy@bentskingo.com</p>
        </div>
      </div>
    </div>
  );
}
